// ** react imports
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// ** router imports
import { useParams, useNavigate } from 'react-router-dom';

// ** components imports
import NormalButton from '../../../../components/common/Buttons/NormalButton';

// ** enums imports
import { BUTTON_THEMES } from '../../../../enums/common';

const CustomerTaxFileHistory = props => {
  // states
  const [data, setData] = React.useState({
    data: [],
    total: 0,
  });

  // hooks
  const { id } = useParams();
  const navigate = useNavigate();

  // render
  if (data.data.length === 0) {
    return (
      <div className="w-full h-full">
        <div className="bg-white h-[calc(75vh)] dark:bg-gray-800 shadow-xs rounded-xl relative overflow-y-auto flex flex-col items-center justify-center gap-4">
          <p className="text-gray-600 dark:text-gray-300 inline-flex items-center-safe">
            <svg
              className="shrink-0 fill-current mr-2 text-gray-400 dark:text-gray-500"
              width="16"
              height="16"
              viewBox="0 0 16 16"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M6 4H4V2H20V4H18V6C18 7.61543 17.1838 8.91468 16.1561 9.97667C15.4532 10.703 14.598 11.372 13.7309 12C14.598 12.628 15.4532 13.297 16.1561 14.0233C17.1838 15.0853 18 16.3846 18 18V20H20V22H4V20H6V18C6 16.3846 6.81616 15.0853 7.8439 14.0233C8.54682 13.297 9.40202 12.628 10.2691 12C9.40202 11.372 8.54682 10.703 7.8439 9.97667C6.81616 8.91468 6 7.61543 6 6V4ZM8 4V6C8 6.88457 8.43384 7.71032 9.2811 8.58583C10.008 9.33699 10.9548 10.0398 12 10.7781C13.0452 10.0398 13.992 9.33699 14.7189 8.58583C15.5662 7.71032 16 6.88457 16 6V4H8ZM12 13.2219C10.9548 13.9602 10.008 14.663 9.2811 15.4142C8.43384 16.2897 8 17.1154 8 18V20H16V18C16 17.1154 15.5662 16.2897 14.7189 15.4142C13.992 14.663 13.0452 13.9602 12 13.2219Z"></path>
              </svg>
            </svg>
            No tax file history found
          </p>

          <div className="flex items-center justify-center">
            <div className="flex items-center gap-3 text-gray-600 dark:text-gray-300">
              <NormalButton
                theme={BUTTON_THEMES.TERTIARY}
                onClick={() =>
                  navigate(`/customers/details/${id}?page=tax-files`)
                }
              >
                <svg
                  className="shrink-0 fill-current mr-2 text-gray-400 dark:text-gray-500"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M19.7784 18.3641L18.3644 19.7783L6.92908 8.34305V13.9288H4.92908L4.92908 4.9288L13.9291 4.9288L13.9291 6.9288L8.34326 6.9288L19.7784 18.3641Z"></path>
                  </svg>
                </svg>
                Select File
              </NormalButton>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full">
      <div className="bg-white h-[calc(75vh)] dark:bg-gray-800 shadow-xs rounded-xl relative overflow-y-auto"></div>
    </div>
  );
};

CustomerTaxFileHistory.propTypes = {};

export default CustomerTaxFileHistory;
